import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'grupo-produtos');

const produtoActions = {
  ...genericActions(basePath),
};

export default resource => resource(`${basePath}`, {}, produtoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/grupo-produto.js